// Create a global bridge for native communication
import { logger } from 'logger';
import monitor from 'utils/monitor';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const LOG = logger.getLogger('VegaOsApi');

interface VegaOs {
  getClosedCaptionsEnabled(): boolean;
  getBuildInfo(): BuildInfo | undefined;
  getAdId(): string | undefined;
  deepLinkToAppOrStore(marketUri: string): void;
  exitApp(): void | undefined;
}

function getClosedCaptionsEnabled(): boolean {
  // Check if closed captions are enabled by default
  const areClosedCaptionsEnabled = !!self.VegaOsInfo?.areCaptionsEnabled;
  LOG.log('Closed Captions Enabled:', areClosedCaptionsEnabled);
  return areClosedCaptionsEnabled;
}

function getBuildInfo(): BuildInfo | undefined {
  return self.VegaOsInfo?.buildInfo;
}

function getAdId(): string | undefined {
  return self.VegaOsInfo?.advertisingId;
}

function exitApp() {
  const exitAppJson = JSON.stringify({ methodName: 'exitApp' });
  LOG.debug('sending message to react native bridge: ', exitAppJson);
  self.ReactNativeWebView?.postMessage?.(exitAppJson);
}

function deepLinkToAppOrStore(marketUri: string): void {
  const vegaMarketUri = marketUri.replace('amzn://', 'amzns://');
  const deepLinkJson = JSON.stringify({ methodName: 'deepLink', marketUri: vegaMarketUri });
  LOG.debug('sending message to react native bridge: ', deepLinkJson);
  self.ReactNativeWebView?.postMessage?.(deepLinkJson);
}

export function getVegaOsApi(): VegaOs | undefined {
  if (self.ReactNativeWebView) {
    return vegaOsApi;
  }

  const errorMessage = 'Requested VegaOsApi before it was defined';
  LOG.error(errorMessage);
  monitor.sendError(errorMessage);

  return undefined;
}

const vegaOsApi: VegaOs = {
  getClosedCaptionsEnabled,
  getBuildInfo,
  getAdId,
  deepLinkToAppOrStore,
  exitApp,
};
